export default __webpack_public_path__ + "static/media/sd-darshanam.5b3ff64a.png";